import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API } from '@app-core/constants/api.constants';
import { setParams } from '@app-core/models/core.model';
import { HttpCacheService } from '@app-core/services/cache/cache.service';
import { CoachAssignmentRequest, CoachResponse } from '@app-shared/common/coach-assignment.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SharedservicesService {
  constructor(private http: HttpClient, private cacheService: HttpCacheService) {}
  public getCoachList(params, isRefresh?: boolean) {
    const httpOptions = {
      params: setParams({ ...params, userType: 'fleetmanager' }),
    };
    if (isRefresh) {
      this.cacheService.burstCache$.next(API.GET_USERS_V2);
    }
    return this.http.get<CoachResponse>(API.GET_USERS_V2, httpOptions);
  }
  public permanentCoachAssignment(body: CoachAssignmentRequest): Observable<any> {
    return this.http.post(API.PERMANENT_COACH_ASSIGNMENT, body);
  }
  public bulkAssignment(uploadedFile: any): Observable<any> {
    const formData: any = new FormData();
    formData.append('drivers', uploadedFile, uploadedFile.name);
    return this.http.post(API.BULK_ASSIGNMENT, formData, { observe: 'response' });
  }
}
